var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectedAccountsEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22V26L11.346 38H22V42H6V38L16.652 26H6V22H22ZM42 6V10L31.346 22H42V26H26V22L36.652 10H26V6H42Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedAccountsEmptyIcon);
export default __webpack_public_path__ + "static/media/connected_accounts_empty_icon.125bf3c6966968217fc84142143911c0.svg";
export { ForwardRef as ReactComponent };